/**
 * Product name shown in shared UI (e.g. app info). Individual games still show their own screen titles.
 */
export const APP_DISPLAY_NAME = "RVLRY";
